import AdaptiveImage from "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js";

export default new AdaptiveImage({
    uri: __webpack_public_path__ + "d1f7aac19e0944e08c781bd1f4e26b56.jpg","uri@2x": __webpack_public_path__ + "b01c8b71bf1f782d3d24e037199c232a.jpg","uri@3x": __webpack_public_path__ + "c241dd08f98a7a045f05662e63dfb2a3.jpg",
    width: 320,
    height: 568
});